// removed by extract-text-webpack-plugin
module.exports = {"errorPage":"_38gSM"};


//////////////////
// WEBPACK FOOTER
// ../source/components/Universal/styles.css
// module id = 1164
// module chunks = 26